import { createFileRoute } from '@tanstack/react-router';

import { CatalogPage } from '@/pages/crm/catalog/CatalogPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/crm/catalog/')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['productCatalog.read'], redirectTo: '/dashboard' }),
	component: CatalogPage,
});
